// assets/js/tweakwise.js

(function () {
  window.twIsLoadingProducts = false;
  window.twIsProductImage = false;
  window.setTwIsProductImage = function (isProduct) {
    window.twIsProductImage = isProduct;
    window.dispatchEvent(
      new CustomEvent("twImageTypeChanged", { detail: isProduct }),
    );
  };
  window.twFilters = {
    applied: [],
    listeners: [],
    getAllFromUrl() {
      const url = new URL(window.location.href);
      const filters = [];
      url.searchParams.forEach((value, key) => {
        if (key.startsWith("tn_fk_")) {
          const urlKey = key.replace(/^tn_fk_/, "");
          const title =
            (window.twFilterTitles && window.twFilterTitles[urlKey]) || urlKey;

          value.split("|").forEach((val) => {
            filters.push({
              name: key,
              value: decodeURIComponent(val),
              display: title + ": " + decodeURIComponent(val),
              full: key + "=" + decodeURIComponent(val),
            });
          });
        }
      });
      return filters;
    },
    setAllToUrl(filters) {
      const url = new URL(window.location.href);
      // Remove all filter params
      Array.from(url.searchParams.keys()).forEach((key) => {
        if (key.startsWith("n_fk_") || key.startsWith("tn_fk_")) {
          url.searchParams.delete(key);
        }
      });
      // Add new ones
      const grouped = {};
      filters.forEach((f) => {
        if (!grouped[f.name]) grouped[f.name] = [];
        grouped[f.name].push(encodeURIComponent(f.value));
      });
      Object.entries(grouped).forEach(([key, values]) => {
        url.searchParams.set(key, values.join("|"));
      });
      history.pushState({}, "", url);
      this.syncFromUrl();
      this.notifyFilterChange();
      window.twFetchAndReplaceProductList(url.toString());
    },
    add(filter) {
      this.applied = this.applied.filter(
        (f) =>
          !(
            f.name === filter.name &&
            f.value.toLowerCase().trim() === filter.value.toLowerCase().trim()
          ),
      );
      this.applied.push(filter);
      this.setAllToUrl(this.applied);
    },
    remove(filter) {
      this.applied = this.applied.filter(
        (f) =>
          !(
            f.name === filter.name &&
            f.value.toLowerCase().trim() === filter.value.toLowerCase().trim()
          ),
      );
      this.setAllToUrl(this.applied);
    },
    clearAll() {
      this.applied = [];
      this.setAllToUrl([]);
    },
    syncFromUrl() {
      this.applied = this.getAllFromUrl();
    },
    onChange(fn) {
      this.listeners.push(fn);
    },
    notifyFilterChange() {
      this.listeners.forEach((fn) => fn(this.applied));
      window.dispatchEvent(
        new CustomEvent("twFiltersChanged", { detail: this.applied }),
      );
    },
  };

  // Sync on load and on popstate (back/forward)
  window.twFilters.syncFromUrl();
  window.addEventListener("popstate", () => window.twFilters.syncFromUrl());

  // Show more/less logic for filter lists
  window.twShowMoreLess = function ({
    containerSelector,
    itemSelector,
    showMoreBtnSelector,
    showLessBtnSelector,
    maxVisible = 10,
  }) {
    var container = document.querySelector(containerSelector);
    if (!container) return;
    var items = container.querySelectorAll(itemSelector);
    var showMoreBtn = document.querySelector(showMoreBtnSelector);
    var showLessBtn = document.querySelector(showLessBtnSelector);
    if (!showMoreBtn || !showLessBtn) return;

    function updateVisibility(showAll) {
      items.forEach(function (item, idx) {
        item.style.display = showAll || idx < maxVisible ? "" : "none";
      });
      if (showAll) {
        showMoreBtn.style.display = "none";
        showLessBtn.style.display = "";
      } else {
        showMoreBtn.style.display = "";
        showLessBtn.style.display = "none";
      }
    }

    showMoreBtn.addEventListener("click", function () {
      updateVisibility(true);
    });
    showLessBtn.addEventListener("click", function () {
      updateVisibility(false);
    });
    updateVisibility(false);
  };

  // Checkbox filter handler for Tweakwise filters
  window.twCheckboxFilterHandler = function (
    checkboxSelector = ".tw-filter-checkbox",
  ) {
    // Remove all previous event listeners by replacing each checkbox with a clone
    document.querySelectorAll(checkboxSelector).forEach(function (checkbox) {
      const newCheckbox = checkbox.cloneNode(true);
      checkbox.parentNode.replaceChild(newCheckbox, checkbox);
    });

    // Now re-select the checkboxes
    document.querySelectorAll(checkboxSelector).forEach(function (checkbox) {
      const filterData = checkbox.getAttribute("data-filter");
      if (!filterData) return;
      let filter;
      try {
        filter = JSON.parse(filterData);
      } catch (e) {
        console.error(e);
        return;
      }
      const value = checkbox.value;
      const url = new URL(window.location);
      const values = getFilterValues(url, "tn_fk_" + filter.urlkey);
      checkbox.checked = values.includes(value);

      checkbox.addEventListener("change", function (e) {
        const filterData = e.target.getAttribute("data-filter");
        if (!filterData) return;
        let filter;
        try {
          filter = JSON.parse(filterData);
        } catch (e) {
          console.error(e);
          return;
        }
        const value = e.target.value;

        const filterObj = {
          name: "tn_fk_" + filter.urlkey,
          value: value,
          display: filter.title + ": " + value,
          full: "tn_fk_" + filter.urlkey + "=" + value,
        };

        if (e.target.checked) {
          window.twFilters.add(filterObj);
        } else {
          window.twFilters.remove(filterObj);
        }
      });
    });

    // Helper
    function getFilterValues(url, filter) {
      const param = url.searchParams.get(filter);
      return param ? param.split("|").map(decodeURIComponent) : [];
    }
  };

  // Sort handler
  window.twSortHandler = function (selectOrValue) {
    const url = new URL(window.location);
    const value =
      typeof selectOrValue === "string" ? selectOrValue : selectOrValue.value;
    url.searchParams.set("sort", value);
    history.pushState({}, "", url);
    window.twFetchAndReplaceProductList(url.toString());
  };

  //Fetch and Replace tw-product-list
  window.twFetchAndReplaceProductList = async function (url) {
    window.twIsLoadingProducts = true;
    window.dispatchEvent(new Event("twProductsLoading"));
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const productList = doc.querySelector("#tw-product-list");
      if (productList) {
        document.querySelector("#tw-product-list").replaceWith(productList);
      }
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      window.twIsLoadingProducts = false;
      window.dispatchEvent(new Event("twProductsLoaded"));
    }
  };
})();
